const pricesData = [
    {
        id: 1,
        name: "SILVER",
        price: "7,000",
        avlServices: [
            {
                text: "VIDEOGRAPHER",
                number: "1"
            },
            {
                text: "hours of filming",
                number: "8"
            },
            {
                text: "wedding filM in minutes",
                number: "10-15"
            },
            {
                text: "highlight video MINutes",
                number: "1"
            },
        ],
        notAvlServices: [
            {
                text: "speeches",
                number: ""
            },
            {
                text: "drone coverage",
                number: ""
            },
        ]
    },

    {
        id: 2,
        name: "GOLD",
        price: "10,000",
        avlServices: [
            {
                text: "VIDEOGRAPHER",
                number: "2"
            },
            {
                text: "hours of filming",
                number: "10"
            },
            {
                text: "wedding filM in minutes",
                number: "12-20"
            },
            {
                text: "highlight video MINutes",
                number: "1-2"
            },
            
        ],
        notAvlServices: [
            {
                text: "speeches",
                number: ""
            },
            {
                text: "drone coverage",
                number: ""
            },
        ]
    },

    {
        id: 3,
        name: "PREMIUM",
        price: "14,500",
        avlServices: [
            {
                text: "VIDEOGRAPHER",
                number: "3"
            },
            {
                text: "hours of filming",
                number: "10"
            },
            {
                text: "wedding filM in minutes",
                number: "12-20"
            },
            {
                text: "highlight video MINutes",
                number: "1-2"
            },
            {
                text: "speeches",
                number: ""
            },
            {
                text: "drone coverage",
                number: ""
            },
        ],
        notAvlServices: [
        ]
    },
];

export default pricesData;